import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'enhanced-img',
    templateUrl: 'img.component.html',
    styleUrls: ['./img.component.scss']
})
export class ImgComponent implements OnChanges {
    private lastSrc: string;

    @Input() src: string;
    @Input() default: string;
    @Input() alt: string;
    private _maxWidthPrepared: string;
    private _maxHeightPrepared: string;
    private _widthPrepared: string;
    private _spinnerHeightPrepared: string;
    get maxWidthPrepared() { return this._maxWidthPrepared; }
    get maxHeightPrepared() { return this._maxHeightPrepared; }
    get widthPrepared() { return this._widthPrepared; }
    get spinnerHeightPrepared() { return this._spinnerHeightPrepared; }
    set maxWidthPrepared(value) { this._maxWidthPrepared = value; }
    set maxHeightPrepared(value) { this._maxHeightPrepared = value; }
    set widthPrepared(value) { this._widthPrepared = value; }
    set spinnerHeightPrepared(value) { this._spinnerHeightPrepared = value; }
    @Input() maxWidth: string | number;
    @Input() width: string | number;
    @Input() maxHeight: string | number;
    @Input() spinnerHeight: string | number;
    @Input() noCache: boolean;

    isCached = false;
    isLoaded = false;
    isFailed = false;

    constructor() { }

    public ngOnChanges() {
        if (this.src !== this.lastSrc) {
            this.lastSrc = this.src;
            this.isLoaded = false;
            this.isFailed = false;
            this.isCached = this.noCache
                ? false
                : this.isUrlCached(this.src);
        }

        this.maxWidthPrepared = typeof (this.maxWidth) === 'number'
            ? this.maxWidth + 'px'
            : this.maxWidth;
        this.maxHeightPrepared = typeof (this.maxHeight) === 'number'
            ? this.maxHeight + 'px'
            : this.maxHeight;
        this.widthPrepared = typeof (this.width) === 'number'
            ? this.width + 'px'
            : this.width;
        this.spinnerHeightPrepared = typeof (this.spinnerHeight) === 'number'
            ? this.spinnerHeight + 'px'
            : this.spinnerHeight;
    }

    public onLoad() {
        this.isLoaded = true;
    }

    public onError() {
        this.isFailed = true;
    }

    private isUrlCached(url: string): boolean {
        if (!url) {
            return false;
        }

        const image = new Image();
        image.src = url;
        const complete = image.complete;

        return complete;
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/img.component.ts